var _path, _rect, _rect2, _line, _line2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _path3, _path4, _path5, _path6, _circle9, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a63c3c50-d1e6-43da-a966-9216c85539b1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1014.53257,
    height: 597.43627,
    viewBox: "0 0 1014.53257 597.43627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "media player") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.73371,747.03187H497.718a4.98426,4.98426,0,0,1-4.98426-4.98426V725.03187h11l4.4213,16.21142a4.58277,4.58277,0,0,1-4.42129,5.78858Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#605d82"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 187.5,
    width: 710,
    height: 270,
    rx: 13.22441,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 0.5,
    width: 962,
    height: 523,
    rx: 13.6378,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 37.03937,
    x2: 962,
    y2: 37.03937,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 100.5,
    x2: 962,
    y2: 100.5,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 22.5,
    r: 10,
    fill: "#f86b75"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 22.5,
    r: 10,
    fill: "#fad375"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 22.5,
    r: 10,
    fill: "#8bcc55"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 18.5,
    r: 10,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 18.5,
    r: 10,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 18.5,
    r: 10,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 74,
    r: 20,
    fill: "#f2f2f2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 69,
    r: 20,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 505,
    y: 63.5,
    width: 99,
    height: 27,
    rx: 5.42323,
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 646,
    y: 63.5,
    width: 99,
    height: 27,
    rx: 5.42323,
    fill: "#6c63ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 55.5,
    width: 99,
    height: 27,
    rx: 4.22244,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 653,
    y: 55.5,
    width: 99,
    height: 27,
    rx: 4.22244,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 165.5,
    width: 710,
    height: 270,
    rx: 16.00394,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M544.6363,516.12246a68.19755,68.19755,0,1,0-78.52266-110.18567m32.62007,31.01634V425.34187l40.92,30.69-9.42,6.5",
    transform: "translate(-92.73371 -151.03187)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M502.37372,394.83187a68.2,68.2,0,1,0,68.2,68.2A68.2316,68.2316,0,0,0,502.37372,394.83187Zm-13.64,98.89v-61.38l40.92,30.69-40.92,30.69Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M475.833,581.73591s-12.24924,42.606-12.78182,61.24619-2.66288,48.46438-1.06515,55.92043,6.39091,22.36818,6.39091,22.36818,10.11893-12.24924,13.847-5.32576c0,0-.53257-14.37954-3.19545-18.64014,0,0,1.06515-22.36818,1.06515-30.35681s13.31439-44.73635,14.37954-45.26892,4.2606,10.11893,1.59773,33.55226-4.79318,64.453-4.79318,68.71361,6.3909,12.78181,10.65151,10.11894,6.92348-25.575,6.92348-25.575,3.728-47.9318,5.85833-53.25755,13.31439-66.572,4.79318-71.36513S475.833,581.73591,475.833,581.73591Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#46455b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M484.88675,720.20556c-.53258,2.1303-2.66288,12.24923-2.66288,15.44469s2.1303,9.05378-6.92348,11.18408c-8.81948,2.077-7.53063-3.42978-8.93663-6.66785-.03725-.0852-.07451-.17043-.11715-.25563-1.59773-3.19545,2.1303-19.70529,2.66287-19.70529.3129,0,2.83184-4.22824,4.85661-7.71633a5.6629,5.6629,0,0,1,8.79069-1.33,8.69329,8.69329,0,0,1,2.64424,6.2769A10.70017,10.70017,0,0,1,484.88675,720.20556Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#605d82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M484.88675,720.20556c-.53258,2.1303-2.66288,12.24923-2.66288,15.44469s2.1303,9.05378-6.92348,11.18408c-8.81948,2.077-7.53063-3.42978-8.93663-6.66785,1.52855-3.973,5.24059-12.5102,7.87148-19.96092,2.322-6.58263,8.03128-4.43637,10.96578-2.7694A10.70017,10.70017,0,0,1,484.88675,720.20556Z",
    transform: "translate(-92.73371 -151.03187)",
    opacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.59773,
    cy: 336.97075,
    r: 11.18409,
    fill: "#fbbebe"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M491.27766,490.13291l-1.59773,17.575,19.17272,3.19545s-2.1303-15.44469-.53257-18.64014S491.27766,490.13291,491.27766,490.13291Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#fbbebe"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M506.18977,503.97988s-15.97726-1.59773-17.04242,0a9.15146,9.15146,0,0,0-1.06515,4.2606s-6.3909,2.66288-7.45605,1.59773-2.13031-4.2606-5.32576-3.19545-9.58636,20.23787-9.58636,20.23787,1.59773-5.85833,4.2606,16.50984,2.13031,36.21514,2.66288,37.81286-2.66288,11.18409,16.50984,11.18409,33.01969-1.06515,33.01969-4.79318-3.19545-19.70529,0-31.422,7.98863-27.69393,7.98863-27.69393l-6.3909-20.77044s-6.39091-1.59773-7.98864,1.06515-5.85833,2.1303-5.85833,2.1303S509.38523,504.51245,506.18977,503.97988Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#605d82"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M475.833,507.70791l-13.31439-5.85833s-25.031-19.17272-23.9659-36.21514c0,0-8.52121-7.98864-9.05379.53257s2.1303,27.69393,8.52121,34.08484,28.22651,26.62878,31.422,27.16135S475.833,507.70791,475.833,507.70791Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#605d82"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M430.564,467.23216s-10.11893-27.69392-1.06515-26.62877,6.92348,12.78181,6.92348,12.78181v13.847Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#fbbebe"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M521.63446,508.77306l13.31439-5.85833s25.03105-19.17272,23.9659-36.21514c0,0,8.52121-7.98863,9.05379.53257s-2.1303,27.69393-8.52121,34.08484-28.22651,26.62878-31.422,27.16135S521.63446,508.77306,521.63446,508.77306Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#605d82"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M566.90339,468.29732s10.11893-27.69393,1.06515-26.62878-6.92348,12.78181-6.92348,12.78181v13.847Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#fbbebe"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M508.85265,474.68822l1.59773-1.06515s-10.11894-5.85833-14.37954-2.66288-5.32576,5.85833-6.39091,6.92349-3.728,6.92348-2.1303,9.05378,1.06515,2.56692,2.1303,4.47891-1.86076,9.60375,6.25939,11.88249,14.51106-7.30761,15.57621-9.43792S516.30871,477.3511,508.85265,474.68822Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#46455b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M917.89678,625.223c0,58.96026,36.98857,106.67016,82.69934,106.67016",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#46455b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.59612,731.89319c0-59.62274,41.2771-107.8687,92.28767-107.8687",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M947.86031,630.56787c0,56.006,23.58691,101.32532,52.73581,101.32532",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#6c63ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.59612,731.89319c0-76.18461,47.7099-137.83223,106.67017-137.83223",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#46455b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M983.19831,732.64523s11.72813-.36121,15.26269-2.87813,18.04081-5.52225,18.91765-1.48567,17.6252,20.07611,4.3842,20.18291-30.76619-2.06249-34.29395-4.21138S983.19831,732.64523,983.19831,732.64523Z",
    transform: "translate(-92.73371 -151.03187)",
    fill: "#a8a8a8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.99915,747.0592c-13.241.10683-30.76618-2.06248-34.29395-4.21138-2.68658-1.63651-3.75715-7.50867-4.11535-10.21786-.24808.01067-.39154.01526-.39154.01526s.74284,9.45882,4.2706,11.60773,21.05295,4.31821,34.29395,4.21138c3.82215-.03083,5.14239-1.39069,5.0699-3.40477C1026.30177,746.27641,1024.844,747.03626,1021.99915,747.0592Z",
    transform: "translate(-92.73371 -151.03187)",
    opacity: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 275,
    y1: 596,
    x2: 512,
    y2: 596,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 876.88769,
    y1: 596.47876,
    x2: 950.88769,
    y2: 596.47876,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPlayer);
export default __webpack_public_path__ + "static/media/media_player.0ea4015f490e478046288cd2fb5364ff.svg";
export { ForwardRef as ReactComponent };